// locales
import 'dayjs/locale/en-gb.js';

// base exports from dayjs
import dayjs from 'dayjs';
// plugins
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import duration from 'dayjs/plugin/duration.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';

// custom utils
import { formatDate, formatDateTime, formatTime } from './formatDate';
import { formatDateRange } from './formatDateRange/formatDateRange';
import { formatDateToDateTimeIsoString } from './formatDateToDateTimeIsoString/formatDateToDateTimeIsoString';
import { formatDateToIsoString } from './formatDateToIsoString';
import { formatElapsedTime } from './formatElapsedTime/formatElapsedTime';
import { formatTimeToIsoString } from './formatTimeToIsoString';
import { getMillisecondsUntil } from './getMillisecondsUntil';
import { getMinutesAsMilliseconds } from './getMinutesAsMilliseconds';
import { getTimeRemaining } from './getTimeRemaining/getTimeRemaining';
import { getTimezoneName } from './getTimezoneName';
import { getTimezoneOffset } from './getTimezoneOffset';
import { isWeekend } from './isWeekend/isWeekend';
import { useElapsedTime } from './useElapsedTime/useElapsedTime';
import { useTimeRemaining } from './useTimeRemaining/useTimeRemaining';

export type { Dayjs } from 'dayjs';
export type { TimeRemaining } from './getTimeRemaining/getTimeRemaining';

export const isDayjs = (d: unknown): d is ReturnType<typeof dayjs> => {
  return dayjs.isDayjs(d);
};

export {
  dayjs,
  formatDate,
  formatDateRange,
  formatDateTime,
  formatDateToDateTimeIsoString,
  formatDateToIsoString,
  formatElapsedTime,
  formatTime,
  formatTimeToIsoString,
  getMillisecondsUntil,
  getMinutesAsMilliseconds,
  getTimeRemaining,
  getTimezoneName,
  getTimezoneOffset,
  isWeekend,
  useElapsedTime,
  useTimeRemaining,
};

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export { duration, isSameOrAfter, relativeTime };
